import { ActionStep, InsightsHandlerResponse } from '@src/clients/seeker/api';
import * as Skeleton from '@src/components/PixxelUIKit/Skeleton';
import { AoiMapPrimaryActionsTools, InsightsStage } from '@src/contexts';
import { Show } from '@src/hoc';
import { useGetBlockDetails } from '@src/hooks/useBlocksHooks';
import { usePaths } from '@src/hooks/usePaths';

import { ToolCard } from './ToolCard';

export const AiInsightCard = ({ step }: { step: ActionStep }) => {
  const toolData = step?.tool_data as InsightsHandlerResponse;
  const blockName = toolData?.blocks?.[0] || '';
  const aoiId = toolData?.aoi_id || '';

  const { navigateToAoiDetails } = usePaths();
  const { data: block, isLoading } = useGetBlockDetails({
    blockName
  });

  if (blockName?.length === 0) return null;

  const { value: cost = 0 } = block?.spec?.price || {};

  const modelRunHelper = () => {
    navigateToAoiDetails({
      aoiId,
      queryParameters: {
        tool: AoiMapPrimaryActionsTools.INSIGHTS,
        stage: InsightsStage.INPUT,
        activeModelId: block.spec.id
      }
    });
  };

  return (
    <Show when={!isLoading} fallback={<Skeleton.ImageList />}>
      <ToolCard
        showButton
        showTokens
        src={`${block?.spec?.thumbnail_url ?? ''}`}
        heading={block?.spec?.title}
        subHeading={block?.spec?.description}
        tokens={
          <>
            Starts from {cost ? cost : 0}/km<sup>2</sup>
          </>
        }
        buttonClick={modelRunHelper}
      />
    </Show>
  );
};
